import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import { GetPropertyProgressDTO } from '../dtos';
import { getPropertyProgress, propertyProgressSelector, resetState } from '../feature';

export const useGetPropertyProgress = (id: string) => {
  const dispatch = useAppDispatch();

  const data = useAppState(propertyProgressSelector);

  useEffect(() => {
    if (!id || data.error) return;
    const dto = new GetPropertyProgressDTO(id);
    dispatch(getPropertyProgress(dto));
  }, [id, data.error]);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, []);

  return data;
};
